import { Injectable } from '@angular/core';
import { UserService } from './user.service';
import { MenuItem, PrimeIcons } from 'primeng/api';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  items: MenuItem[] = [];
  reminderCount: string = "0";

  constructor(
    private userService: UserService
  ) { }

  setItems() {
    this.items = [
      {
        label: "Management", visible: this.userService.hasAnyRole(["admin", "editor", "booking_viewer", "contact_request_viewer"]),
        items: [
          { label: "Reminder", icon: "pi pi-bitcoin", badge: this.reminderCount, routerLink: "/management/payment-reminders", visible: this.userService.hasAnyRole(["admin", "editor", "booking_viewer"]) },
          { label: "Leads", icon: "pi pi-users", routerLink: "/management/leads", visible: this.userService.hasAnyRole(["admin", "editor", "contact_request_viewer"]) },
          { label: "Partners", icon: "pi pi-briefcase", routerLink: "/management/schools", visible: this.userService.hasAnyRole(["admin", "editor", "booking_viewer"]) },
          { label: "Booking requests", icon: "pi pi-user-plus", routerLink: "/management/create-booking", visible: this.userService.hasAnyRole(["admin", "editor", "booking_viewer"]) },
          { label: "All Bookings", icon: "pi pi-id-card", routerLink: "/management/bookings", visible: this.userService.hasAnyRole(["admin", "editor", "booking_viewer"]) },
          { label: "My Bookings", icon: "pi pi-bookmark", routerLink: "/management/my-bookings", visible: this.userService.hasAnyRole(["admin", "editor", "booking_viewer"]) },
          { label: "My Invoices", icon: PrimeIcons.HEART, routerLink: "/management/my-invoices", visible: this.userService.hasAnyRole(["admin", "editor", "booking_viewer"]) },
          { label: "Create Group Booking", routerLink: "/management/create-group-booking", visible: this.userService.hasAnyRole(["admin", "editor"]) },
          { label: "Group Bookings", routerLink: "/management/group-bookings", visible: this.userService.hasAnyRole(["admin", "editor", "booking_viewer"]) }
        ]
      },
      {
        label: "Templates", visible: this.userService.hasAnyRole(["admin", "editor"]),
        items: [
          //PDF Templates for leads
          { label: "Confirmation templates", icon: "pi pi-folder-open", routerLink: "/management/quotation-templates" },
          //Email templates for contact requests
          { label: "Lead Mails", icon: "pi pi-folder-open", routerLink: "/management/lead-email-templates" },
          //PDF templates for bookings
          { label: "Booking reports", icon: "pi pi-folder-open", routerLink: "/management/pdf-templates" },
          //Email templates for bookings
          { label: "Booking Mails", icon: "pi pi-folder-open", routerLink: "/management/booking-email-templates" }
        ]
      },
      {
        label: "Tools", visible: this.userService.hasAnyRole(["admin", "editor"]),
        items: [
          { label: "Wiki", icon: "pi pi-compass", routerLink: "/management/guides" },
          { label: "External links", icon: "pi pi-pencil", routerLink: "/management/manage-links" },
          { label: "Sales Report", icon: "pi pi-chart-line", routerLink: "/management/sales-report" },
          { label: "Global Files", routerLink: "/management/global-booking-files" }
        ]
      },
      {
        label: "Accounting", visible: this.userService.hasAnyRole(["admin", "editor"]),
        items: [
          { label: "General Invoices", icon: "pi pi-inbox", routerLink: "/management/general-supplier-invoice/invoices" },
          { label: "Transactions", routerLink: "/management/transactions" },
          { label: "Payments", routerLink: "/management/payments-received" },
          { label: "Add Refund Request", icon: "pi pi-dollar", routerLink: "/management/refund-request-new" },
          { label: "Refund Requests", icon: "pi pi-dollar", routerLink: "/management/refund-requests" }
        ]
      },
      {
        label: "Sales Invoice", visible: this.userService.hasAnyRole(["superadmin", "accountant"]),
        items: [
          { label: "AVI Invoices", routerLink: "/management/avi-invoices" },
          { label: "Add recipient", routerLink: "/management/create-sales-invoice-recipient" },
          { label: "Add AVI Invoice", routerLink: "/management/create-avi-invoice" }
        ]
      },
      {
        label: "Settings", visible: this.userService.hasAnyRole(["admin", "editor"]),
        items: [
          { label: "Autofil Config", icon: "pi pi-cog", visible: this.userService.isNot("directrice"), routerLink: "/management/autofill" },
          { label: "Manage Users", icon: "pi pi-id-card", visible: this.userService.hasRole("admin"), routerLink: "/management/users" },
        ]
      },
      {
        label: "Other", visible: this.userService.hasAnyRole(["admin", "editor"]),
        items: [
          { label: "Salon", icon: "pi pi-directions", routerLink: "/management/siep-contacts" },
          { label: "Mail Template", icon: "pi pi-envelope", routerLink: "/management/email-template", styleClass: "ui-menuitem-text-red" },
          { label: "Promotions", icon: "pi pi-volume-up", routerLink: "/management/promotions" },
          { label: "Grouped Invoice", icon: "pi pi-list", routerLink: "/management/create-invoices" },
          { label: "All Invoices", icon: "pi pi-money-bill", routerLink: "/management/all-invoices" }
        ]
      },
      {
        label: "Tool testing", visible: this.userService.hasRole("developer"),
        items: [
          { label: "School Invoices not validated", routerLink: "/management/school-invoices-to-validate" },
          { label: "Agent commission", routerLink: "/management/agent-commission", visible: this.userService.hasAnyRole(["admin", "editor"]) },
          { label: "PDF Template CSS", icon: "pi pi-folder-open", routerLink: "/management/pdf-template-csses" },
          { label: "ETC Form Test", icon: "pi pi-table", routerLink: "/etc-parental-permission/431dc427-c7f1-4b44-b4b6-6b16142bf515" },
          { label: "ETC New Booking", icon: "pi pi-user-plus", routerLink: "/management/create-etc-booking" },
          { label: "ETC Bookings", icon: "pi pi-users", routerLink: "/management/bookings-etc" },
          { label: "Remove WP Tags", visible: this.userService.hasAnyRole(["admin", "editor"]), icon: "pi pi-filter", routerLink: "/management/strip-wp" },
          { label: "Create Invoice", routerLink: "/management/create-sales-invoice" },
          { label: "Invoices", routerLink: "/management/sales-invoices" },
          { label: "Test Constant Contact API", routerLink: "/management/test-constant-contact" },
          { label: "PrimeNG Sandbox", routerLink: "/management/test-primeng" },
          { label: "Statistiques", routerLink: "/management/booking-statistiques" },
          { label: "Gmail API", icon: "pi pi-google", routerLink: "/management/test-gmail-api" },
          { label: "PDF Templates V2", icon: "pi pi-android", routerLink: "/management/pdf-templates-beta" },
          { label: "Find School by Programme", routerLink: "/management/programmes" },
          { label: "Test client dashboard general", routerLink: "/dashboard-student/" + environment.mockBookingUuid },
          { label: "Test Bruges Form", routerLink: "/test-bruges-form" },
          { label: "Constant contact", routerLink: "/management/constant-contact" }
        ]
      },
      {
        label: "Bruges",
        items: [
          { label: "Dashboard", icon: "pi pi-list", routerLink: "/management/bookings-bruges" },
          { label: "New Booking", visible: this.userService.hasAnyRole(["admin", "editor"]), icon: "pi pi-plus-circle", routerLink: "/management/create-booking-bruges" },
          { label: "Current Bookings", icon: "pi pi-star-o", routerLink: "/management/bookings-current" },
          { label: "Deleted Bookings", visible: this.userService.hasAnyRole(["admin", "editor"]), icon: "pi pi-trash", routerLink: "/management/bookings-deleted" },
        ]
      }
    ];
  }
}
